import { ReactElement } from 'react';
import { HiOutlineChevronRight } from 'react-icons/hi2';

interface AccordionIconProps {
  show: boolean;
}

export function AccordionIcon(props: AccordionIconProps): ReactElement {
  const { show } = props;
  return (
    <HiOutlineChevronRight
      className={`cr-size-5 cr-stroke-[3px]
              cr-transition-transform cr-duration-[300ms] ${show && 'cr-rotate-90'}`}
    />
  );
}

export default AccordionIcon;
